module.exports = __webpack_public_path__ + "img/20.b0dca954.jpg";